import i18n from '@/lang'
import OrderSelect from '@pt/components/order-select.vue'
import SearchInput from '@pt/components/search-input.vue'
import { ProductType } from '@pt/enums/product'

export const dateOptions: { value: string; label: string }[] = [
  {
    label: `${i18n.t('playTurbo.promoteManagement.promote.table.updatetime')}`,
    value: 'updated_time',
  },
  {
    label: `${i18n.t('playTurbo.videoProject.table.createTime')}`,
    value: 'created_time',
  },
]

export const searchFormSchema = [
  {
    type: 'object',
    properties: {
      name: {
        component: SearchInput,
        class: 'search-name',
        field: {
          placeholder: i18n.t(
            'playTurbo.promoteManagement.promote.filter.placeholder',
          ),
        },
      },
      type: {
        component: 'select',
        field: {
          placeholder: i18n.t('playTurbo.assetLibrary.asset.filter.types'),
          options: [
            {
              label: 'APP',
              value: 'app',
            },
            {
              label: 'Website',
              value: 'website',
            },
            {
              label: i18n
                .t('playTurbo.promoteManagement.promote.wxgame.title')
                .toString(),
              value: 'wxgame',
            },
          ],
          clearable: true,
          multiple: true,
          checkable: true,
          'collapse-tags': true,
        },
      },
      platform: {
        component: 'select',
        field: {
          placeholder: i18n.t(
            'playTurbo.promoteManagement.promote.filter.platform',
          ),
          clearable: true,
          multiple: true,
          checkable: true,
          'collapse-tags': true,
          options: [
            {
              label: 'iOS',
              value: 'ios',
            },
            {
              label: 'Android',
              value: 'android',
            },
          ],
        },
      },
      order: {
        component: OrderSelect,
        field: {
          placeholder: i18n.t('playTurbo.whole.promote.choice'),
          options: dateOptions,
        },
      },
    },
  },
]

export const getPlatformInfo = (type: string) => {
  let returnData = ''
  switch (type) {
    case 'ios':
      returnData = 'iOS'
      break
    case 'android':
      returnData = 'Android'
      break
    case 'android,ios':
      returnData = 'iOS & Android'
      break
    default:
      returnData = '-'
      break
  }
  return returnData
}

export const getProductType = (type: ProductType): string => {
  let returnData = ''
  switch (type) {
    case ProductType.APP:
      returnData = 'APP'
      break
    case ProductType.Website:
      returnData = 'Website'
      break
    case ProductType.WXGame:
      returnData = i18n
        .t('playTurbo.promoteManagement.promote.wxgame.title')
        .toString()
      break
    default:
      returnData = '-'
      break
  }
  return returnData
}
